import Paper from '@mui/material/Paper/Paper'
import styled from '@mui/material/styles/styled'

export const ProfileItem = styled(Paper)(({ theme }) => ({
	backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
	...theme.typography.body2,
	padding: theme.spacing(3),
	borderRadius: '12px',
	boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.08)',
}))
